import { IAuthUser } from '../auth/types';
import { IAppState } from '../types';

export const getAuthUser = (state: IAppState): IAuthUser | undefined => state.auth.authUser;
export const getRehydrated = (state: IAppState): boolean => state.auth.rehydrated;
